import type { FC } from "react";

import {
  CAT_GENDER_ICON_MAP,
  type TCatOverviewCardProps,
} from "@/ui/components/data-display/Card/CatOverviewCard/CatOverviewCard.config";
import {
  CatOverviewDetail,
} from "@/ui/components/data-display/Card/CatOverviewCard/CatOverviewDetail";
import { Article, Container, Flex } from "@/ui/components/layout";
import { Button, Pill, PolaroidImage } from "@/ui/components/primitives";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import { useCatOverviewCard } from "./useCatOverviewCard";

export const CatOverviewCard: FC<TCatOverviewCardProps> = ({
  cat,
  image,
  editLabel,
  onEdit,
}) => {

  const { defaultLabels, details, eatingSince } = useCatOverviewCard(cat);

  return (
    <Article
      data-component="CatOverviewCard"
      className="w-full rounded-sys-sm border border-solid border-component-card-base bg-sys-white p-6 shadow-neo-brutal"
    >
      <Flex align="start" justify="between" gap="4">
        <Container className="w-auto mx-0">
          <TextSubtitle tag="h2" size={1} isResponsive={false}>{ cat.name }</TextSubtitle>
          { eatingSince ? (
            <Pill icon="filledCircleTick" variant="benefit" className="mt-1">{ eatingSince }</Pill>
          ): null }
        </Container>
        <Button variant="tertiary" onClick={onEdit}>{ editLabel || defaultLabels.edit }</Button>
      </Flex>

      <Flex align="center" className="mt-4">
        <PolaroidImage image={image} className="w-28 h-32" />
        <Flex direction="column" align="start" gap="2" className="px-4 flex-1">
          <CatOverviewDetail
            icon="cake"
            label={details.birthday.label}
            value={details.birthday.value}
          />
          <CatOverviewDetail icon="cat" label={details.breed.label} value={details.breed.value} />
          <CatOverviewDetail
            icon={CAT_GENDER_ICON_MAP[cat.gender]}
            label={details.neutured.label}
            value={details.neutured.value}
          />
        </Flex>
      </Flex>
    </Article>
  );
};

CatOverviewCard.displayName = "CatOverviewCard";
